var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "mtlink-banner mtlink-banner_js_open-modal",
        class: [
          _vm.classNames.triggerOpenPopup,
          { "mtlink-banner_box-shadow": _vm.hasBoxShadow },
        ],
      },
      [
        _c("img", {
          staticClass: "mtlink-banner__medtochka-logo mr-8",
          attrs: {
            src: "/static/_v1/pd/logos/ui-kit/medtochka-logo.svg",
            alt: _vm.$i18next.t("Логотип МедТочки", { ns: _vm.userLanguage }),
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2 mr-3" }, [
          _vm._v("\n      " + _vm._s(_vm.text) + "\n    "),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ui-icon-circle-info ml-auto" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }